import { create } from 'zustand';

/**
 * UI store — ephemeral UI state (modals, drawers, toasts).
 *
 * AuthModal — глобальная модалка входа. Открывается из Navbar (landing)
 * и из ProtectedRoute (когда access-токен истёк). Используется вместо
 * отдельного /app/auth route в большинстве сценариев.
 *
 * После успешного входа модалка закрывается автоматически.
 */
export interface AuthModalOptions {
  /** Куда перенаправить после успешного входа (только если явно нужно). */
  redirectTo?: string;
  /** Заголовок модалки (по умолчанию 'Вход в Aura'). */
  title?: string;
}

interface UiStore {
  /** Модалка авторизации. */
  authModalOpen: boolean;
  authModalOptions: AuthModalOptions;
  openAuthModal: (options?: AuthModalOptions) => void;
  closeAuthModal: () => void;

  /** Mobile drawer для landing (если понадобится). */
  drawerOpen: boolean;
  setDrawerOpen: (open: boolean) => void;

  /**
   * Composer новой публикации.
   *
   * Живёт в сторе, а не в состоянии экрана: кнопку «Создать» показывают и
   * топбар, и мобильная панель, и пустая лента. Пока состояние было
   * локальным, каждая поверхность заводила своё — а оболочка вообще не
   * могла открыть модалку и уводила на несуществующий маршрут.
   */
  composerOpen: boolean;
  openComposer: () => void;
  closeComposer: () => void;
}

export const useUiStore = create<UiStore>((set) => ({
  authModalOpen: false,
  authModalOptions: {},
  openAuthModal: (options = {}) =>
    set({ authModalOpen: true, authModalOptions: options }),
  closeAuthModal: () =>
    set((state) => ({
      authModalOpen: false,
      authModalOptions: {},
      // сохраняем drawerClosed тоже — на всякий случай
      drawerOpen: state.drawerOpen,
    })),

  drawerOpen: false,
  setDrawerOpen: (open) => set({ drawerOpen: open }),

  composerOpen: false,
  openComposer: () => set({ composerOpen: true }),
  closeComposer: () => set({ composerOpen: false }),
}));
